// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2988":"3ef3f2c2","3585":"9fd9c01a"}[chunkId] + ".chunk.css";
};